// import React, { useCallback, useEffect, useState } from "react";
// import { OnboardPageProps } from "../../models/OnboardPageProps";
// import { UserAuth } from "../../context/AuthContext";
// import { get, ref, update, set, remove } from "firebase/database";
// import { database } from "../../firebase";
// import { Typography, Paper, Stack, Slider, FormControl, InputLabel, Select, MenuItem, TextField, Grid, IconButton } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import CheckIcon from "@mui/icons-material/Check";
// import DeleteIcon from "@mui/icons-material/Delete";

// export interface LifestyleModel {
//   title: string;
//   sleepHours: number;
//   screenTime: number;
//   exerciseFrequency: string;
//   dietQuality: string;
//   demographicSize: number | "";
// }

// // Inline Card Component for Lifestyle Habits
// const LifestyleCard = ({ habitProp, deleteCallback, editModeProp }: { habitProp: LifestyleModel, deleteCallback: () => void, editModeProp?: boolean }) => {
//   const auth = UserAuth();
//   const [editMode, setEditMode] = useState(editModeProp || false);
//   const [habit, setHabit] = useState<LifestyleModel>(habitProp);

//   const handleChange = (field: keyof LifestyleModel, value: any) => {
//     setHabit({ ...habit, [field]: value });
//   };

//   const saveChanges = () => {
//     if (auth?.user && habit.title.trim() !== "") {
//       const habitRef = ref(database, `users/${auth.user.id}/lifestyleHabits/${habit.title}`);
//       get(habitRef).then((snapshot) => {
//         if (snapshot.exists()) {
//           update(habitRef, habit);
//         } else {
//           set(habitRef, habit);
//         }
//       });
//     }
//     setEditMode(false);
//   };

//   return (
//     <Paper style={{ padding: "1.5rem", borderRadius: "5px", backgroundColor: "#F3F5EA", border: "1px solid #ddd", height: "100%", display: "flex", flexDirection: "column" }}>
//       <Stack direction={"row"} justifyContent={"space-between"} alignItems="flex-start" mb={3}>
//         {editMode ? (
//           <TextField variant="outlined" label="Group Title (e.g. Students)" size="small" value={habit.title} onChange={(e) => handleChange("title", e.target.value)} />
//         ) : (
//           <Typography variant="h5" fontWeight="bold">{habit.title || "Untitled Group"}</Typography>
//         )}
//         <Stack direction={"row"} spacing={1}>
//           {editMode ? (
//             <>
//               <IconButton onClick={saveChanges} color="success"><CheckIcon /></IconButton>
//               <IconButton onClick={deleteCallback} color="error"><DeleteIcon /></IconButton>
//             </>
//           ) : (
//             <IconButton onClick={() => setEditMode(true)} color="success"><EditIcon /></IconButton>
//           )}
//         </Stack>
//       </Stack>

//       <Stack spacing={3} sx={{ flexGrow: 1 }}>
//         {editMode ? (
//           <TextField variant="outlined" fullWidth size="small" type="number" label="Total People in this Demographic" value={habit.demographicSize || ""} onChange={(e) => handleChange("demographicSize", e.target.value === "" ? "" : Number(e.target.value))} InputProps={{ inputProps: { min: 0 } }} />
//         ) : (
//           <Typography variant="subtitle2">Demographic Size: {habit.demographicSize || "Not specified"}</Typography>
//         )}

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Sleep Hours per night: {habit.sleepHours} hours</Typography>
//           <Slider disabled={!editMode} value={habit.sleepHours} onChange={(e, val) => handleChange("sleepHours", val)} step={1} marks min={0} max={12} color="success" />
//         </div>

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Screen Time per day: {habit.screenTime} hours</Typography>
//           <Slider disabled={!editMode} value={habit.screenTime} onChange={(e, val) => handleChange("screenTime", val)} step={1} marks min={0} max={16} color="success" />
//         </div>

//         <FormControl fullWidth size="small" disabled={!editMode}>
//           <InputLabel>Exercise Frequency</InputLabel>
//           <Select value={habit.exerciseFrequency} label="Exercise Frequency" onChange={(e) => handleChange("exerciseFrequency", e.target.value)}>
//             <MenuItem value="Never">Never</MenuItem>
//             <MenuItem value="1-2x per week">1-2x per week</MenuItem>
//             <MenuItem value="3+ per week">3+ per week</MenuItem>
//           </Select>
//         </FormControl>

//         <FormControl fullWidth size="small" disabled={!editMode}>
//           <InputLabel>Diet Quality</InputLabel>
//           <Select value={habit.dietQuality} label="Diet Quality" onChange={(e) => handleChange("dietQuality", e.target.value)}>
//             <MenuItem value="Poor">Poor</MenuItem>
//             <MenuItem value="Average">Average</MenuItem>
//             <MenuItem value="Good">Good</MenuItem>
//           </Select>
//         </FormControl>
//       </Stack>
//     </Paper>
//   );
// };

// const PreferencesForm = (props: OnboardPageProps) => {
//   const auth = UserAuth();
//   const [habits, setHabits] = useState<{ id: string, data: LifestyleModel, editMode: boolean }[]>([]);

//   const fetchHabits = useCallback(async () => {
//     if (auth?.user) {
//       const prefsRef = ref(database, `users/${auth.user.id}/lifestyleHabits`);
//       const snapshot = await get(prefsRef);
//       const data = snapshot.val();
//       if (data) {
//         // Filter out old non-collection formats just in case
//         const parsedArray = Object.entries(data)
//           .filter(([_, val]) => typeof val === 'object' && val !== null && 'title' in (val as any))
//           .map(([id, val]) => ({ id, data: val as LifestyleModel, editMode: false }));
//         setHabits(parsedArray);
//       }
//     }
//   }, [auth?.user]);

//   useEffect(() => { fetchHabits(); }, [fetchHabits]);

//   const saveData = useCallback(() => {
//     console.log("Lifestyle habits saved on per-card basis.");
//   }, []);

//   useEffect(() => { props.registerSave(saveData); }, [props, props.registerSave, saveData]);

//   const handleAdd = () => {
//     setHabits([...habits, {
//       id: Date.now().toString(),
//       data: { title: "", sleepHours: 7, screenTime: 4, exerciseFrequency: "1-2x per week", dietQuality: "Average", demographicSize: "" },
//       editMode: true
//     }]);
//   };

//   const handleDelete = (idToRemove: string, titleToRemove: string) => {
//     setHabits((prev) => prev.filter((item) => item.id !== idToRemove));
//     if (auth?.user && titleToRemove) {
//       remove(ref(database, `users/${auth.user.id}/lifestyleHabits/${titleToRemove}`));
//     }
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
//       <Typography variant="h4" sx={{ marginTop: "1rem", textAlign: "center" }}>Lifestyle Habits</Typography>
//       <Stack direction="row" justifyContent="flex-end" width="100%" mb={2}>
//         <IconButton onClick={handleAdd} color="success" size="large"><AddIcon fontSize="inherit" /></IconButton>
//       </Stack>
//       <Grid container spacing={3}>
//         {habits.map((item) => (
//           <Grid item xs={12} md={6} key={item.id}>
//             <LifestyleCard habitProp={item.data} deleteCallback={() => handleDelete(item.id, item.data.title)} editModeProp={item.editMode} />
//           </Grid>
//         ))}
//       </Grid>
//     </div>
//   );
// };

// export default PreferencesForm;


// import React, { useCallback, useEffect, useState } from "react";
// import { OnboardPageProps } from "../../models/OnboardPageProps";
// import { UserAuth } from "../../context/AuthContext";
// import { get, ref, set, remove } from "firebase/database";
// import { database } from "../../firebase";
// import { Typography, Paper, Stack, Slider, FormControl, InputLabel, Select, MenuItem, TextField, Grid, Button } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteIcon from "@mui/icons-material/Delete";

// export interface LifestyleModel {
//   title: string;
//   sleepHours: number;
//   screenTime: number;
//   exerciseFrequency: string;
//   dietQuality: string;
//   demographicSize: number | "";
// }

// // FIX: Added updateCallback to props
// const LifestyleCard = ({ habitId, habitProp, deleteCallback, updateCallback }: { habitId: string, habitProp: LifestyleModel, deleteCallback: () => void, updateCallback: (data: LifestyleModel) => void }) => {
//   const auth = UserAuth();
//   const [habit, setHabit] = useState<LifestyleModel>(habitProp);

//   const autoSaveToFirebase = (dataToSave: LifestyleModel) => {
//     if (auth?.user) {
//       set(ref(database, `users/${auth.user.id}/lifestyleHabits/${habitId}`), dataToSave);
//     }
//   };

//   const handleChange = (field: keyof LifestyleModel, value: any) => {
//     const updatedHabit = { ...habit, [field]: value };
//     setHabit(updatedHabit);
//     autoSaveToFirebase(updatedHabit);
//     updateCallback(updatedHabit); // FIX: Send data to parent
//   };

//   const handleTextChange = (field: keyof LifestyleModel, value: any) => {
//     const updatedHabit = { ...habit, [field]: value };
//     setHabit(updatedHabit);
//     updateCallback(updatedHabit); // FIX: Send data to parent
//   };

//   const handleBlur = () => {
//     autoSaveToFirebase(habit);
//   };

//   return (
//     <Paper style={{ padding: "1.5rem", borderRadius: "8px", backgroundColor: "#F3F5EA", border: "1px solid #ddd", height: "100%", display: "flex", flexDirection: "column" }}>
//       <Stack spacing={3} sx={{ flexGrow: 1 }}>
//         <TextField
//           variant="standard"
//           placeholder="Group Title (e.g. Students)"
//           value={habit.title}
//           onChange={(e) => handleTextChange("title", e.target.value)}
//           onBlur={handleBlur}
//           InputProps={{ style: { fontSize: '1.5rem', fontWeight: 'bold' } }}
//         />

//         <TextField
//           variant="outlined"
//           fullWidth
//           size="small"
//           type="number"
//           label="Target Demographic (Number of people)"
//           value={habit.demographicSize || ""}
//           onChange={(e) => handleTextChange("demographicSize", e.target.value === "" ? "" : Number(e.target.value))}
//           onBlur={handleBlur}
//           InputProps={{ inputProps: { min: 0 } }}
//         />

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Sleep Hours per night: {habit.sleepHours} hours</Typography>
//           <Slider value={habit.sleepHours} onChange={(e, val) => handleChange("sleepHours", val)} step={1} marks min={0} max={12} color="success" />
//         </div>

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Screen Time per day: {habit.screenTime} hours</Typography>
//           <Slider value={habit.screenTime} onChange={(e, val) => handleChange("screenTime", val)} step={1} marks min={0} max={16} color="success" />
//         </div>

//         <FormControl fullWidth size="small">
//           <InputLabel>Exercise Frequency</InputLabel>
//           <Select value={habit.exerciseFrequency} label="Exercise Frequency" onChange={(e) => handleChange("exerciseFrequency", e.target.value)}>
//             <MenuItem value="Never">Never</MenuItem>
//             <MenuItem value="1-2x per week">1-2x per week</MenuItem>
//             <MenuItem value="3+ per week">3+ per week</MenuItem>
//           </Select>
//         </FormControl>

//         <FormControl fullWidth size="small">
//           <InputLabel>Diet Quality</InputLabel>
//           <Select value={habit.dietQuality} label="Diet Quality" onChange={(e) => handleChange("dietQuality", e.target.value)}>
//             <MenuItem value="Poor">Poor</MenuItem>
//             <MenuItem value="Average">Average</MenuItem>
//             <MenuItem value="Good">Good</MenuItem>
//           </Select>
//         </FormControl>
//       </Stack>

//       <Stack direction="row" justifyContent="flex-end" mt={3}>
//         <Button size="small" color="error" startIcon={<DeleteIcon />} onClick={deleteCallback}>
//           Delete
//         </Button>
//       </Stack>
//     </Paper>
//   );
// };

// const PreferencesForm = (props: OnboardPageProps) => {
//   const auth = UserAuth();
//   const [habits, setHabits] = useState<{ id: string, data: LifestyleModel }[]>([]);

//   const fetchHabits = useCallback(async () => {
//     if (auth?.user) {
//       const prefsRef = ref(database, `users/${auth.user.id}/lifestyleHabits`);
//       const snapshot = await get(prefsRef);
//       if (snapshot.exists()) {
//         const parsedArray = Object.entries(snapshot.val()).map(([id, val]) => ({
//           id, data: val as LifestyleModel
//         }));
//         setHabits(parsedArray);
//       }
//     }
//   }, [auth?.user]);

//   useEffect(() => { fetchHabits(); }, [fetchHabits]);

//   const saveData = useCallback(() => {
//     return habits.map(h => h.data);
//   }, [habits]);

//   useEffect(() => { props.registerSave(saveData); }, [props, saveData]);

//   const handleAdd = () => {
//     const newId = Date.now().toString();
//     const newHabit: LifestyleModel = { title: "", sleepHours: 7, screenTime: 4, exerciseFrequency: "1-2x per week", dietQuality: "Average", demographicSize: "" };

//     setHabits([...habits, { id: newId, data: newHabit }]);

//     if (auth?.user) {
//       set(ref(database, `users/${auth.user.id}/lifestyleHabits/${newId}`), newHabit);
//     }
//   };

//   const handleDelete = (idToRemove: string) => {
//     setHabits((prev) => prev.filter((item) => item.id !== idToRemove));
//     if (auth?.user) {
//       remove(ref(database, `users/${auth.user.id}/lifestyleHabits/${idToRemove}`));
//     }
//   };

//   // FIX: Master update function for the array
//   const handleUpdate = (idToUpdate: string, updatedData: LifestyleModel) => {
//     setHabits((prev) => prev.map(item => item.id === idToUpdate ? { ...item, data: updatedData } : item));
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
//       <Typography variant="h4" sx={{ marginTop: "1rem", textAlign: "center" }}>Lifestyle Habits</Typography>
//       <Stack direction="row" justifyContent="flex-end" width="100%" mb={2}>
//         <Button variant="outlined" color="success" startIcon={<AddIcon />} onClick={handleAdd}>Add Demographic</Button>
//       </Stack>
//       <Grid container spacing={3}>
//         {habits.map((item) => (
//           <Grid item xs={12} md={6} key={item.id}>
//             <LifestyleCard
//               habitId={item.id}
//               habitProp={item.data}
//               deleteCallback={() => handleDelete(item.id)}
//               updateCallback={(data) => handleUpdate(item.id, data)} // FIX: Hooked up!
//             />
//           </Grid>
//         ))}
//       </Grid>
//     </div>
//   );
// };

// export default PreferencesForm;


//15-04

import React, { useCallback, useEffect, useState } from "react";
// REMOVED: import { UserAuth } from "../../context/AuthContext";
// REMOVED: import { get, ref, set, remove } from "firebase/database";
// REMOVED: import { database } from "../../firebase";
import { OnboardPageProps } from "../../models/OnboardPageProps";
import { Typography, Paper, Stack, Slider, FormControl, InputLabel, Select, MenuItem, TextField, Grid, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export interface LifestyleModel {
  title: string;
  sleepHours: number;
  screenTime: number;
  exerciseFrequency: string;
  dietQuality: string;
  demographicSize: number | "";
}

const LifestyleCard = ({
  habitId,
  habitProp,
  deleteCallback,
  updateCallback
}: {
  habitId: string,
  habitProp: LifestyleModel,
  deleteCallback: () => void,
  updateCallback: (data: LifestyleModel) => void
}) => {
  const [habit, setHabit] = useState<LifestyleModel>(habitProp);

  const handleChange = (field: keyof LifestyleModel, value: any) => {
    const updatedHabit = { ...habit, [field]: value };
    setHabit(updatedHabit);
    updateCallback(updatedHabit);
  };

  const handleTextChange = (field: keyof LifestyleModel, value: any) => {
    const updatedHabit = { ...habit, [field]: value };
    setHabit(updatedHabit);
    updateCallback(updatedHabit);
  };

  return (
    <Paper style={{ padding: "1.5rem", borderRadius: "8px", backgroundColor: "#F3F5EA", border: "1px solid #ddd", height: "100%", display: "flex", flexDirection: "column" }}>
      <Stack spacing={3} sx={{ flexGrow: 1 }}>
        <TextField
          variant="standard"
          placeholder="Group Title (e.g. Students)"
          value={habit.title}
          onChange={(e) => handleTextChange("title", e.target.value)}
          // REMOVED: onBlur
          InputProps={{ style: { fontSize: '1.5rem', fontWeight: 'bold' } }}
        />

        <TextField
          variant="outlined"
          fullWidth
          size="small"
          type="number"
          label="Target Demographic (Number of people)"
          value={habit.demographicSize || ""}
          onChange={(e) => handleTextChange("demographicSize", e.target.value === "" ? "" : Number(e.target.value))}
          InputProps={{ inputProps: { min: 0 } }}
        />

        <div>
          <Typography variant="subtitle2" gutterBottom>Sleep Hours per night: {habit.sleepHours} hours</Typography>
          <Slider value={habit.sleepHours} onChange={(e, val) => handleChange("sleepHours", val)} step={1} marks min={0} max={12} color="success" />
        </div>

        <div>
          <Typography variant="subtitle2" gutterBottom>Screen Time per day: {habit.screenTime} hours</Typography>
          <Slider value={habit.screenTime} onChange={(e, val) => handleChange("screenTime", val)} step={1} marks min={0} max={16} color="success" />
        </div>

        <FormControl fullWidth size="small">
          <InputLabel>Exercise Frequency</InputLabel>
          <Select value={habit.exerciseFrequency} label="Exercise Frequency" onChange={(e) => handleChange("exerciseFrequency", e.target.value)}>
            <MenuItem value="Never">Never</MenuItem>
            <MenuItem value="1-2x per week">1-2x per week</MenuItem>
            <MenuItem value="3+ per week">3+ per week</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth size="small">
          <InputLabel>Diet Quality</InputLabel>
          <Select value={habit.dietQuality} label="Diet Quality" onChange={(e) => handleChange("dietQuality", e.target.value)}>
            <MenuItem value="Poor">Poor</MenuItem>
            <MenuItem value="Average">Average</MenuItem>
            <MenuItem value="Good">Good</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <Stack direction="row" justifyContent="flex-end" mt={3}>
        <Button size="small" color="error" startIcon={<DeleteIcon />} onClick={deleteCallback}>
          Delete
        </Button>
      </Stack>
    </Paper>
  );
};

const PreferencesForm = (props: OnboardPageProps) => {
  // Initialize as empty array (no fetching from Firebase)
  const [habits, setHabits] = useState<{ id: string, data: LifestyleModel }[]>([]);

  // Pass current local state back to the parent
  const saveData = useCallback(() => {
    return habits.map(h => h.data);
  }, [habits]);

  useEffect(() => { props.registerSave(saveData); }, [props, saveData]);

  const handleAdd = () => {
    const newId = Date.now().toString(); // Local temp ID
    const newHabit: LifestyleModel = {
      title: "",
      sleepHours: 7,
      screenTime: 4,
      exerciseFrequency: "1-2x per week",
      dietQuality: "Average",
      demographicSize: ""
    };

    setHabits([...habits, { id: newId, data: newHabit }]);
  };

  const handleDelete = (idToRemove: string) => {
    setHabits((prev) => prev.filter((item) => item.id !== idToRemove));
  };

  const handleUpdate = (idToUpdate: string, updatedData: LifestyleModel) => {
    setHabits((prev) => prev.map(item => item.id === idToUpdate ? { ...item, data: updatedData } : item));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Typography variant="h4" sx={{ marginTop: "1rem", textAlign: "center" }}>Lifestyle Habits</Typography>
      <Stack direction="row" justifyContent="flex-end" width="100%" mb={2}>
        <Button variant="outlined" color="success" startIcon={<AddIcon />} onClick={handleAdd}>Add Demographic</Button>
      </Stack>
      <Grid container spacing={3}>
        {habits.map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
            <LifestyleCard
              habitId={item.id}
              habitProp={item.data}
              deleteCallback={() => handleDelete(item.id)}
              updateCallback={(data) => handleUpdate(item.id, data)}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default PreferencesForm;
